module.exports = __webpack_public_path__ + "img/logo-footer.008d8c2a.svg";